var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664787 8.489H2.30903V15.2581C2.30903 15.3917 2.41732 15.5 2.55096 15.5H5.33884C5.47248 15.5 5.58077 15.3917 5.58077 15.2581V8.52089H7.47096C7.59387 8.52089 7.69727 8.42866 7.7113 8.30658L7.99838 5.81455C8.00627 5.74598 7.98454 5.67732 7.93867 5.62589C7.89275 5.5744 7.82704 5.54494 7.75809 5.54494H5.58087V3.98281C5.58087 3.5119 5.83442 3.27311 6.33455 3.27311C6.40582 3.27311 7.75809 3.27311 7.75809 3.27311C7.89174 3.27311 8.00003 3.16477 8.00003 3.03118V0.743726C8.00003 0.610081 7.89174 0.50179 7.75809 0.50179H5.79624C5.7824 0.501113 5.75167 0.5 5.70638 0.5C5.36598 0.5 4.18277 0.566823 3.24813 1.42666C2.21254 2.3795 2.3565 3.52037 2.3909 3.71818V5.54489H0.664787C0.531142 5.54489 0.422852 5.65318 0.422852 5.78682V8.24702C0.422852 8.38066 0.531142 8.489 0.664787 8.489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social_facebook.10a78374b70dcf6e246fb01994402acf.svg";
export { ForwardRef as ReactComponent };